import axios from "axios";

const TOKEN_KEY = "token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    window.location.href = "/login";
};

// Axios für /api/admin/*: Token pro Request, bei abgelaufenem Login zurück zur Anmeldung.
const api = axios.create({ baseURL: "/api/admin" });

api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response && error.response.status;
        if (status === 401 || status === 403) {
            logout();
        }
        return Promise.reject(error);
    },
);

export const errorMessage = (error, fallback) =>
    (error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
    fallback;

export default api;
